export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'handler-companies',
      displayName: 'Kezelő cégek',
      meta: {
        icon: 'business',
      },
    },
    {
      name: 'client-invoices',
      displayName: 'Aktív számlák',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'email-history',
      displayName: 'Számla emailek',
      meta: {
        icon: 'receipt',
      },
    },
    {
      name: 'client-emails',
      displayName: 'Kiküldött emailek',
      meta: {
        icon: 'email',
      },
    },
    {
      name: 'xml-manager',
      displayName: 'XML Kezelő',
      meta: {
        icon: 'folder_open',
      },
    },
    {
      name: 'reports',
      displayName: 'Kimutatások',
      meta: {
        icon: 'assessment',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        showInSidebar: false,
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
